import React from "react";
import FilterFlightsSidebarSkeleton from "./FilterFlightsSkeletonInner";

function FlightListingSkeleton({ tripTypeID }) {
  return (
    <div className="container mx-auto px-3 animate-pulse">
      <div className="grid lg:grid-cols-4 grid-cols-1 lg:gap-4">
        <FilterFlightsSidebarSkeleton />
        <div className="col-span-3 sflex-1 flex-col lg:py-4">
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm mb-3">
            <div className="grid grid-cols-1 lg:grid-cols-8 lg:gap-4 text-sm p-2 md:p-4">
              <div className="col-span-6 grid grid-cols-4 gap-1 md:gap-4">
                <div className="col-span-4 md:col-span-1">
                  <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                  <div className="flex items-center gap-2">
                    <div className="flex flex-col items-start justify-start ">
                      <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                    </div>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center">
                  <div className="md:text-center">
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span className="text-muted-foreground"></span>
                    </div>
                  </div>
                </div>
                <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                  <div>
                    <h3></h3>
                    <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                      <hr className="w-full " />
                      <div className="flex gap-x-2"></div>
                    </div>
                    <h3></h3>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center md:text-center">
                  <div>
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span></span>
                    </div>
                  </div>
                </div>
                {tripTypeID == "2" &&
                  <>
                    <div className="col-span-4 md:col-span-1">
                      <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col items-start justify-start ">
                          <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                        </div>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center">
                      <div className="md:text-center">
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span className="text-muted-foreground"></span>
                        </div>
                      </div>
                    </div>
                    <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                      <div>
                        <h3></h3>
                        <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                          <hr className="w-full " />
                          <div className="flex gap-x-2"></div>
                        </div>
                        <h3></h3>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center md:text-center">
                      <div>
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
              <div
                className="col-span-2 
 flex border-t lg:border-t-0 lg:border-l 
 justify-between border-dotted 
 flex-wrap items-center 
 lg:justify-center gap-x-2 pt-2 
 lg:p-0 mt-2 lg:m-0 pl-0 lg:pl-3"
              >
                <span className="font-medium text-lg"> </span>
                <i className=" h-10 px-4 py-2"> </i>
              </div>
            </div>
            <div className="flex items-center justify-between dark:bg-gray-600 bg-gray-200 px-3">
              <span className="text-primary text-sm"></span>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary underline-offset-4 hover:underline h-10 py-2 px-0"></button>
            </div>
          </div>
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm mb-3">
            <div className="grid grid-cols-1 lg:grid-cols-8 lg:gap-4 text-sm p-2 md:p-4">
              <div className="col-span-6 grid grid-cols-4 gap-1 md:gap-4">
                <div className="col-span-4 md:col-span-1">
                  <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                  <div className="flex items-center gap-2">
                    <div className="flex flex-col items-start justify-start ">
                      <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                    </div>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center">
                  <div className="md:text-center">
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span className="text-muted-foreground"></span>
                    </div>
                  </div>
                </div>
                <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                  <div>
                    <h3></h3>
                    <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                      <hr className="w-full " />
                      <div className="flex gap-x-2"></div>
                    </div>
                    <h3></h3>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center md:text-center">
                  <div>
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span></span>
                    </div>
                  </div>
                </div>
                {tripTypeID == "2" &&
                  <>
                    <div className="col-span-4 md:col-span-1">
                      <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col items-start justify-start ">
                          <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                        </div>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center">
                      <div className="md:text-center">
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span className="text-muted-foreground"></span>
                        </div>
                      </div>
                    </div>
                    <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                      <div>
                        <h3></h3>
                        <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                          <hr className="w-full " />
                          <div className="flex gap-x-2"></div>
                        </div>
                        <h3></h3>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center md:text-center">
                      <div>
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
              <div
                className="col-span-2 
 flex border-t lg:border-t-0 lg:border-l 
 justify-between border-dotted 
 flex-wrap items-center 
 lg:justify-center gap-x-2 pt-2 
 lg:p-0 mt-2 lg:m-0 pl-0 lg:pl-3"
              >
                <span className="font-medium text-lg"> </span>
                <i className=" h-10 px-4 py-2"> </i>
              </div>
            </div>
            <div className="flex items-center justify-between dark:bg-gray-600 bg-gray-200 px-3">
              <span className="text-primary text-sm"></span>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary underline-offset-4 hover:underline h-10 py-2 px-0"></button>
            </div>
          </div>
          <div className="rounded-lg border bg-card text-card-foreground shadow-sm mb-3">
            <div className="grid grid-cols-1 lg:grid-cols-8 lg:gap-4 text-sm p-2 md:p-4">
              <div className="col-span-6 grid grid-cols-4 gap-1 md:gap-4">
                <div className="col-span-4 md:col-span-1">
                  <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                  <div className="flex items-center gap-2">
                    <div className="flex flex-col items-start justify-start ">
                      <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                    </div>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center">
                  <div className="md:text-center">
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span className="text-muted-foreground"></span>
                    </div>
                  </div>
                </div>
                <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                  <div>
                    <h3></h3>
                    <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                      <hr className="w-full " />
                      <div className="flex gap-x-2"></div>
                    </div>
                    <h3></h3>
                  </div>
                </div>
                <div className="flex md:items-center md:justify-self-center md:text-center">
                  <div>
                    <p className="font-medium lg:text-lg"></p>
                    <div className="text-muted-foreground">
                      <span></span>
                    </div>
                  </div>
                </div>
                {tripTypeID == "2" &&
                  <>
                    <div className="col-span-4 md:col-span-1">
                      <p className="font-medium text-muted-foreground text-xs uppercase mb-2 tracking-wide"></p>
                      <div className="flex items-center gap-2">
                        <div className="flex flex-col items-start justify-start ">
                          <h2 className="font-medium text-sm md:text-md text-muted-foreground md:text-foreground"></h2>
                        </div>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center">
                      <div className="md:text-center">
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span className="text-muted-foreground"></span>
                        </div>
                      </div>
                    </div>
                    <div className="flex col-span-2 items-center justify-self-center text-center md:col-span-1 text-muted-foreground">
                      <div>
                        <h3></h3>
                        <div className="relative flex items-center justify-center h-2 md:h-4 text-center *:absolute z-0">
                          <hr className="w-full " />
                          <div className="flex gap-x-2"></div>
                        </div>
                        <h3></h3>
                      </div>
                    </div>
                    <div className="flex md:items-center md:justify-self-center md:text-center">
                      <div>
                        <p className="font-medium lg:text-lg"></p>
                        <div className="text-muted-foreground">
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </>
                }
              </div>
              <div
                className="col-span-2 
 flex border-t lg:border-t-0 lg:border-l 
 justify-between border-dotted 
 flex-wrap items-center 
 lg:justify-center gap-x-2 pt-2 
 lg:p-0 mt-2 lg:m-0 pl-0 lg:pl-3"
              >
                <span className="font-medium text-lg"> </span>
                <i className=" h-10 px-4 py-2"> </i>
              </div>
            </div>
            <div className="flex items-center justify-between dark:bg-gray-600 bg-gray-200 px-3">
              <span className="text-primary text-sm"></span>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary underline-offset-4 hover:underline h-10 py-2 px-0"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlightListingSkeleton;